<template>
	<section class="container">
        <div class="table-container">
            <div class="title row1">
                <img class="logo" src="../assets/icon/ic_soc.png" alt="S">
                Group E-learning
            </div>
            <div class="title row2">
                註冊申請狀態
                <span class="sub-title">(若對申請結果有疑問，可聯繫各部門管理員)</span>
            </div>
            <!-- 分頁 -->
            <el-col :span="24" class="page-bar">
                <div class="total-results"> {{totalResult}} </div>
                <el-pagination v-if="list.length > 0" 
                    layout="prev, pager, next" 
                    prev-text="prev" 
                    next-text="next" 
                    :current-page="pagination.currentPage" 
                    @current-change="handleCurrentChange" 
                    :page-size="pagination.pageSize" 
                    :total="total" 
                    style="float:right;">
                </el-pagination>
            </el-col>
            <!--列表-->
            <el-table :data="currentList" v-loading="listLoading"
                    style="width:100%;cursor:default;" empty-text="暫無資料">
                <el-table-column min-width="30%" prop="date" label="申請日期" :formatter="formatDate">
                </el-table-column>
                <el-table-column min-width="30%" prop="name" label="申請人"> 
                </el-table-column>
                <el-table-column min-width="25%" prop="id" label="工號"> 
                </el-table-column>
                <el-table-column min-width="15%" prop="status" label="狀態">
                    <template slot-scope="scope">	
                        <div v-if="scope.row.status === null">
                            <div>審核中</div>
                        </div>
                        <div v-else-if="scope.row.status === 1">
                            <div style="color: #008F05;">通過</div>
                        </div>
                        <div v-else-if="scope.row.status === 0">
                            <div style="color: #D00000;">不通過</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分頁 -->
            <el-col :span="24" class="page-bar">
                <el-pagination v-if="list.length > 0" 
                    layout="prev, pager, next" 
                    prev-text="prev" 
                    next-text="next" 
                    :current-page="pagination.currentPage" 
                    @current-change="handleCurrentChange" 
                    :page-size="pagination.pageSize" 
                    :total="total" 
                    style="float:right;">
                </el-pagination>
            </el-col>
        </div>
        
    </section>
</template>

<script>
import API from '@/api/api';  
import util from '@/common/js/util';
export default {
    name: 'RegResult',
    data() {
      return {
        list: [],
        currentList: [],
        totalResult: '',
        total: 0,
        listLoading: false,
        pagination: {
            currentPage: 1,
            offset: 0,
            pageSize: 50,
        }
      };
    },
    methods: {
        init() {
            this.list.splice(0);
            this.listLoading = true;
            API.getRegisterList().then((response) => {
                if(response.status) {
                    if(!JSON.parse(response.request.response).error_msg) {
                    this.$message.error('獲得註冊列表發生錯誤');
                    } else {
                    this.$message.error(JSON.parse(response.request.response).error_msg);
                    }
                } else {
                    this.total = response.length;
                    for (let i = 0 ; i < response.length ; i++) {
                        let obj = {};
                        obj.date = response[i].date * 1000;
                        let displayname = response[i].displayname;
                        let length = displayname.length;
                        if (length > 1) {
                            displayname = displayname.slice(0, -(length - 1));
                            for (let j = 0 ; j < length - 1 ; j++) {
                                displayname = displayname + "Ｏ"
                            }
                        }
                        obj.name = displayname;
                        obj.id = response[i].name;
                        obj.status = response[i].status;
                        
                        this.list.push(obj);
                    }
                    this.currentList = this.list.slice(0, this.pagination.pageSize);
                    this.updateTotalResult();
                    
                }
                this.listLoading = false;
            });
        },
        updateTotalResult() {
            if(this.total === 0) {
                this.totalResult = ' 共 0 筆結果';
            } else {
                this.totalResult = this.pagination.pageSize * (this.pagination.currentPage - 1) + 
                    1 + ' - ' + (this.pagination.pageSize * (this.pagination.currentPage - 1) + 
                    this.currentList.length) + ' 筆，' + ' 共 ' + this.total + ' 筆帳號';
            }
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.pagination.offset = this.pagination.pageSize * (this.pagination.currentPage - 1);
            let start = this.pagination.offset;
            this.currentList = this.list.slice(start, start + this.pagination.pageSize);
            this.updateTotalResult();
        },
        formatDate(row) {
            return util.formatDate.format(new Date(row.date), 'yyyy-MM-dd');
        },
    },
    created() {
      this.init();
    },
  }
</script>
<style lang="scss" scoped>
    .container {
        overflow-y: auto;
        background-color: #F5F8FA;

        .title {
            color: #1D2327;
        }

        .row1 {
            margin-top: 36px;
            font-size: 22px;
            font-weight: 600;
            height: 48px;
            line-height: 48px;

            .logo {
                height: 28px;
                position: relative;
                top: 5px;
            }
        }

        .row2 {
            margin-top: 20px;
            margin-bottom: 20px;
            font-size: 24px;
            font-weight: 500;

            .sub-title {
                color: #515151;
                font-size: 14px;
                font-weight: 0;
            }
        }

        .table-container {
            width: 92%;
            margin: 30px auto 80px;
        }
    }
</style>


// WEBPACK FOOTER //
// RegResult.vue?bdba3cb8